/**
 * The main js file for the theme
 *
 * This is the entry point where all modules are imported and compiled.
 *
 * @package Globus
 * @since   1.0.0
 */

/**
 * Polyfills for features not supported by all browsers.
 *
 * @since 1.0.1
 */
import './modules/theme/polyfills';

/**
 * Lazy-load images with 'vanilla-lazyload',
 * and initialize picturefill after they've loaded.
 *
 * @since 1.0.0
 */
import './modules/theme/images';

/**
 * Add classes to image and video thumbnail links, and setup
 * click events to open the image/video in a Colorbox modal.
 *
 * @since 1.0.0
 */
import './modules/theme/lightboxes';

/**
 * Make file inputs and select elements easier to style.
 *
 * @since 1.0.0
 */
import './modules/theme/forms';

/**
 * Scroll to hash on click. Scroll to hash on load.
 *
 * @since 1.0.0
 */
import './modules/theme/scroll-to';

/**
 * Toggle 'scrolled' class on sticky header.
 *
 * @since 1.0.0
 */
import './modules/theme/sticky-header';

/**
 * Toggle 'scrolled' class on sticky section.
 *
 * @since 1.0.0
 */
import './modules/theme/sticky-section';

/**
 * Toggle 'scrolled' class on sticky header.
 *
 * @since 1.0.0
 */
import './modules/theme/main-menu';

/**
 * Spotlight slider.
 *
 * @since 1.0.0
 */
import './modules/theme/block-spotlight-slider';

/**
 * Comment Reply
 *
 * @since 1.0.0
 */
import './modules/theme/comment-reply';

/**
 * Masthead
 *
 * @since 1.0.0
 */
import './modules/theme/masthead';

/**
 * Search click functionality
 *
 * @since 1.0.0
 */
import './modules/theme/search';

/**
 * Latest Tweets slider
 *
 * @since 1.0.0
 */
import './modules/theme/latest-tweets';

/**
 * Gallery Preview
 *
 * @since 1.0.0
 */
import './modules/theme/gallery-preview';

/**
 * Gallery Preview
 *
 * @since 1.0.0
 */
import './modules/theme/trauma';

/**
 * Gallery Preview
 *
 * @since 1.0.0
 */
import './modules/theme/hot-spot';

/**
 * Table Sorting functionlaity
 *
 * @since 1.0.0
 */
import './modules/theme/resource-filter';

/**
 * event functionlaity
 *
 * @since 1.0.0
 */
import './modules/theme/event-filter';

/**
 * Table Sorting functionlaity
 *
 * @since 1.0.0
 */
import './modules/theme/surgeon-locator';

/**
 * Table Sorting functionlaity
 *
 * @since 1.0.0
 */
import './modules/theme/tables';

/**
 * slide animation functionlaity
 *
 * @since 1.0.0
 */
import './modules/theme/slide-animation';

/**
 * responsive-block-spacer
 *
 * @since 1.0.0
 */
import './modules/theme/responsive-block-spacer';

/**
 * Events slider
 *
 * @since 1.0.0
 */
import './modules/theme/cards-slider';

/**
 * Educational Opportunities slider
 *
 * @since 1.0.0
 */
import './modules/theme/ed-op-slider';

/**
 * Testimonial slider
 *
 * @since 1.0.0
 */
import './modules/theme/test-slider';

/**
 * Study slider
 *
 * @since 1.0.0
 */
import './modules/theme/study-slider';

/**
 * INR tabs
 *
 * @since 1.0.0
 */
import './modules/theme/inr-tabs';

/**
 * Links
 *
 * @since 1.0.0
 */
import './modules/theme/links';
